import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireAuth = false }) {
  const { isAuthenticated, isChecking, isAdmin } = useAuth();
  const location = useLocation();

  if (isChecking) {
    return (
      <div
        data-testid="protected-checking"
        className="min-h-screen bg-matte flex items-center justify-center"
      >
        <div className="flex flex-col items-center gap-4">
          <div className="relative h-14 w-14 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full border border-gold/30" />
            <div className="absolute inset-0 rounded-full border-t-2 border-gold animate-spin" />
            <div className="h-2 w-2 rounded-full bg-gold" />
          </div>
          <span className="text-[11px] tracking-[0.4em] uppercase text-white/50 font-display">
            Verifying session
          </span>
        </div>
      </div>
    );
  }

  // Only genuinely private routes force a login. Public browsing runs as Guest.
  if (requireAdmin && !isAdmin) {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return <Navigate to="/app/dashboard" replace />;
  }
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
